/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Leaving1Inputs */

const zh_organizationsettings_leaving1 = /** @type {(inputs: Organizationsettings_Leaving1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离开中...`)
};

const en_organizationsettings_leaving1 = /** @type {(inputs: Organizationsettings_Leaving1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leaving...`)
};

const es_organizationsettings_leaving1 = /** @type {(inputs: Organizationsettings_Leaving1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonando...`)
};

/**
* | output |
* | --- |
* | "Leaving..." |
*
* @param {Organizationsettings_Leaving1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_leaving1 = /** @type {((inputs?: Organizationsettings_Leaving1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Leaving1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_leaving1(inputs)
	if (locale === "en") return en_organizationsettings_leaving1(inputs)
	return es_organizationsettings_leaving1(inputs)
});
export { organizationsettings_leaving1 as "organizationSettings_leaving" }